import { render } from "./FormSubmission.vue?vue&type=template&id=34f9021e"
import script from "./FormSubmission.vue?vue&type=script&lang=ts"
export * from "./FormSubmission.vue?vue&type=script&lang=ts"
script.render = render

export default script